module.exports = {
    "baseUrl": "https://api-v4.staging.primrose.health",
    "systemName": "System dev",
    "companyTitle": "Review | Trillium Health",
    "metaTitle": "Trillium Health",
    "favicon": "%PUBLIC_URL%/favicon.png",
    "redirectUrl": "https://tensaw.health/",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "companyKey": "trillium",
    "cdnUrl": "https://cdn.staging.primrose.health"
}